import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextMedium, TextRegular } from 'UiKit/typography';
import Badge from 'UiKit/badge';
import useGetHostScheduleDetail from 'Domain/host/useGetHostScheduleDetail';
import { Condition } from 'Component/others';

import RescheduleBadgeStatus from 'View/reschedule-form/component/reschedule-badge-status';
import getBadgeVariant from 'View/host/helper/getBadgeVariant';
import FieldDescription from 'View/host/component/field-description';
import { SkeletonDetailOverview } from 'View/host-detail/component/skeleton';

import styles from './styles.module.css';

const DetailOverview = () => {
  const { t } = useTranslation('host-schedule');
  const { data, isFetching } = useGetHostScheduleDetail();

  const badgeVariant = getBadgeVariant(data?.achievementStatus);

  const isRescheduleApproved = data?.reschedule?.statusProgress === 'Diterima';

  return (
    <Box className={styles['detail-overview__container']}>
      <Condition statement={!isFetching} fallback={<SkeletonDetailOverview />}>
        <Box className={styles['head__section']}>
          <Box className={styles['schedule-title__conatiner']}>
            <TextMedium className={styles['schedule-title__text']}>{data?.title}</TextMedium>
            <Condition statement={isRescheduleApproved}>
              <RescheduleBadgeStatus status="Diterima" />
            </Condition>
          </Box>
          <Condition statement={data?.achievementStatus}>
            <Badge variant={badgeVariant} size="sm" className={styles['badge']}>
              <Condition statement={data?.achievementStatus === 'Achievement Tersedia'}>{t('achievement_status.available')}</Condition>
              <Condition statement={data?.achievementStatus === 'Achievement Belum Tersedia'}>{t('achievement_status.not_available')}</Condition>
            </Badge>
          </Condition>
          <TextRegular className={styles['schedule-date__text']}>{data?.datetime}</TextRegular>
        </Box>

        <Box className={styles['content__section']}>
          <FieldDescription label={t('card.account')} value={data?.account} />
          <FieldDescription label={t('card.platform')} value={data?.platform} />
          <FieldDescription label={t('card.host')} value={data?.host} />
          <FieldDescription label={t('card.operator')} value={data?.operator} />
          <FieldDescription label={t('card.room_studio_name')} value={data?.room} />
        </Box>
      </Condition>
    </Box>
  );
};

export default DetailOverview;
